import { useCallback } from "react";

import { faExclamationTriangle } from "@performyard/fontawesome/pro-regular-svg-icons";
import { SurveyModelJson } from "@performyard/service-contracts";

// store
import {
	useActions as useSurveyBuilderActions,
	useSetters as useSurveyBuilderSetters,
} from "../pages/SurveyBuilder/store/store";

import { useSetters as useSurveyDetailsSetters } from "../store/store";

import { useGetSurvey } from "../../../../../api/hooks/defs/surveys";

export const useSurvey = ({ surveyId }: { surveyId: string }) => {
	const { data: survey, isLoading } = useGetSurvey(surveyId);
	const surveyBuilderSetters = useSurveyBuilderSetters();
	const surveyBuilderActions = useSurveyBuilderActions();
	const surveyDetailsSetters = useSurveyDetailsSetters();

	const storeSurvey = (surveyToStore: SurveyModelJson) => {
		surveyBuilderActions.resetStore();
		// set store to a deep copy of the survey questions
		const surveyQuestionsDraft = [...surveyToStore.questions].map((question) => ({ ...question }));
		surveyBuilderSetters.setSurveyName(surveyToStore.name);
		surveyBuilderSetters.setSurveyQuestionsDraft(surveyQuestionsDraft);
		surveyBuilderActions.sortQuestionsByOrder();
		surveyDetailsSetters.setSurveyStatus(surveyToStore.status);
		surveyBuilderSetters.setEditingQuestion(null);
		if (surveyToStore.surveyLink) {
			surveyDetailsSetters.setSurveyLink(`${window.location.origin}${surveyToStore.surveyLink}`);
		}
		if (surveyToStore.questions.length === 0) {
			surveyBuilderActions.addSurveyQuestion();
		}
		if (surveyToStore.status === "closed") {
			surveyBuilderSetters.setBuilderBanner({
				message: "This survey is closed and cannot be edited.",
				color: "primary",
				icon: faExclamationTriangle,
			});
		}
	};

	const isQuestionInSurvey = useCallback(
		(questionId: string): boolean => {
			return (survey?.questions.map((question) => question._id) || []).includes(questionId);
		},
		[survey]
	);

	return {
		isQuestionInSurvey,
		storeSurvey,
		isLoading,
		survey,
	};
};
